import { render, staticRenderFns } from "./ElementStudioVideoOptions.vue?vue&type=template&id=563fd947&"
import script from "./ElementStudioVideoOptions.vue?vue&type=script&lang=ts&"
export * from "./ElementStudioVideoOptions.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports